import { Button, Divider, Icons, Stack } from '@healthinal/ui';
import { ReactNode } from 'react';

interface Props {
  onAbortClick: () => void;
  disableSubmit?: boolean;
  isLoading?: boolean;
  children?: ReactNode;
}
export function FormActionButtons({ onAbortClick, disableSubmit, isLoading, children }: Props) {
  return (
    <>
      <Divider inset="context" />
      <Stack direction={'row'}>
        {children}
        <Stack flex={1} direction="row" justifyContent="flex-end" gap={1}>
          <Button endDecorator={<Icons.Close />} color="neutral" onClick={onAbortClick}>
            Abbrechen
          </Button>
          <Button endDecorator={<Icons.Check />} type="submit" disabled={disableSubmit} loading={isLoading}>
            Speichern
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
